<template>
    <div class="session-wrapper">
        <div class="session-right text-xs-center">
            <div class="session-table-cell">
                <div class="session-content">
                    <img
                        :src="appLogo"
                        class="img-responsive mb-4"
                        style="max-width: 300px"
                        :style="$bp.smallScreen ? 'margin-left: -15px' : 'margin-left: 15px'"
                    />
                    <v-layout row wrap v-if="mode == 'rfid'" class="black--text">
                        <v-flex xs12 mx-auto>
                            <v-layout row mx-auto>
                                <v-flex :class="$bp.smallScreen ? 'display-2' : 'display-3'">
                                    {{ login_loader ? "Loading" : "Scan Card" }}
                                </v-flex>
                                <v-flex mt-auto ml-4 :class="[$bp.smallScreen ? 'mb-2' : 'mb-3']">
                                    <div class="animation" :class="login_loader ? 'dot-falling' : 'dot-typing'"></div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-icon class="display-4" style="font-family: Material Icons !important">payment</v-icon>
                        </v-flex>
                        <v-flex xs12>
                            <p class="fs-14">
                                <a @click="switchMode('login')"><v-icon class="mr-1">keyboard_backspace</v-icon>Login with credentials</a>
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-form v-else v-model="valid" ref="login_form" class="mb-4">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-focus
                                    v-model="logDetails.username"
                                    :label="$t('lang.username')"
                                    :placeholder="!usernameAutofilled ? ' ' : ''"
                                    :rules="usernameRules"
                                    required
                                    maxLength="100"
                                    @keyup.enter="submit"
                                    @focus="$event.target.select()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-password-input
                                    v-model="logDetails.password"
                                    :label="$t('lang.password')"
                                    :placeholder="!passwordAutoFilled ? ' ' : ''"
                                    :rules="$r.required(true)"
                                    :counter="false"
                                    required
                                    @keyup.enter="submit"
                                    @focus="$event.target.select()"
                                ></bc-password-input>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout row>
                                    <v-flex inner-flex>
                                        <v-checkbox v-model="logDetails.remember_me" :label="$t('lang.remember_me')" color="primary" class="mt-2"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs2 inner-flex v-if="include_qr_login">
                                        <bc-scan-barcode
                                            ref="scan_barcode"
                                            scan-object="user_qr_code"
                                            header-text="Scan QR Code "
                                            @scanned="submit_qr($event)"
                                        ></bc-scan-barcode>
                                    </v-flex>
                                    <v-flex xs2 inner-flex v-if="include_rfid_login">
                                        <bc-tooltip>
                                            <template slot="activator">
                                                <v-btn icon @mouseup.left="switchMode('rfid')">
                                                    <v-icon class="fs-30 material-icons-outlined">payment</v-icon>
                                                </v-btn>
                                            </template>
                                            RFID Reader
                                        </bc-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <div class="mb-4">
                            <v-btn large @mouseup.left="submit()" @keyup.enter="submit()" block color="primary" class="white--text" :disabled="signing_in">
                                {{ !login_loader ? $t("lang.loginNow") : null }}
                                <v-progress-circular v-if="login_loader" indeterminate color="white"></v-progress-circular>
                            </v-btn>
                        </div>
                        <!-- <p class="fs-14">{{$t('lang.dontHaveAn')}} {{ brand }} {{ $t('lang.accountYet') }}
							<router-link to="/session/sign-up">{{ $t('lang.createAccount') }}.</router-link>
						</p> -->
                        <p class="fs-14">
                            {{ $t("lang.forgotPassword") }}?
                            <router-link to="/session/forgot_password">{{ $t("lang.resetPassword") }}.</router-link>
                        </p>
                    </v-form>

                    <div class="alert alert-danger text-center" v-if="errorMessage">
                        <button type="button" class="close" @mouseup.left="clearMessage()"><span aria-hidden="true">&times;</span></button>
                        <span class="glyphicon glyphicon-alert"></span> {{ errorMessage }}
                    </div>

                    <div class="alert alert-success text-center" v-if="successMessage">
                        <button type="button" class="close" @mouseup.left="clearMessage()"><span aria-hidden="true">&times;</span></button>
                        <span class="glyphicon glyphicon-check"></span> {{ successMessage }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AppConfig from "Constants/AppConfig";
import api from "Api";
import Vue from "vue";
import ScanQrCode from "Components/Header/ScanQrCode";

export default {
    components: { ScanQrCode },
    data() {
        return {
            signing_in: false,
            sign_in_timer: "",
            successMessage: "",
            errorMessage: "",
            logDetails: {
                username: "",
                password: "",
                remember_me: false,
            },
            checkbox: false,
            valid: false,
            usernameRules: [],
            passwordRules: [],
            appLogo: AppConfig.appLogo2,
            brand: AppConfig.brand,
            usernameAutofilled: false,
            passwordAutoFilled: false,
            redirect: false,
            include_qr_login: true,
            include_rfid_login: true,
            rfid_value: "",
            mode: "login",
            test: false,
            rfid_timer: "",
        };
    },
    watch: {
        "logDetails.username"() {
            this.usernameAutofilled = true;
        },
        "logDetails.password"() {
            this.passwordAutoFilled = true;
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setAlert(to, from);
        });
    },
    mounted: function () {
        if (this.$route.params && this.$route.params.redirect) {
            this.redirect = this.$route.params.redirect;
        }
        this.$store.commit("toggleLoginLoader", false);
        this.$store.commit("toggleHelpArticleMenuHandler", false); // close HelpArticleMenu
        this.$nextTick(() => {
            this.finishLoader();
        });
    },
    computed: {
        ...mapState({
            login_loader: (state) => state.settings.login_loader,
        }),
    },
    methods: {
        activateRFID() {
            this.rfid_value = "";
            window.addEventListener("keydown", this.checkKeydown);
        },
        deactivateRFID() {
            window.removeEventListener("keydown", this.checkKeydown);
        },
        switchMode(mode) {
            if (mode == "rfid") {
                this.activateRFID();
            } else if (mode == "login") {
                this.deactivateRFID();
                this.rfid_value = "";
            }
            this.mode = mode;
            this.$store.commit("toggleLoginLoader", false);
        },
        // method to read in rfid input
        checkKeydown(e) {
            const key = e.key;
            if (key == "Enter") {
                this.deactivateRFID();
                this.submit_rfid(this.rfid_value);
                clearTimeout(this.rfid_timer);
            } else {
                if (!this.login_loader) {
                    this.$store.commit("toggleLoginLoader", true);
                    this.rfid_timer = setTimeout(() => {
                        this.rfid_timer = null;
                        this.deactivateRFID();
                        this.$nextTick(() => {
                            this.activateRFID();
                            this.$store.commit("toggleLoginLoader", false);
                            this.createAlert("error", "scan_again");
                        });
                    }, 10000); // 10 seconds
                }
                this.rfid_value += key;
            }
        },
        setAlert(to, from) {
            if (to && to.params && to.params.redirect && from && from.fullPath !== "/") {
                let alert_message = this.$t("lang.session_timed_out");
                setTimeout(function () {
                    Vue.notify({
                        group: "loggedIn",
                        type: "error",
                        text: alert_message,
                    });
                }, 1000);
            }
        },
        submit_rfid(rfid) {
            var redirect = "";
            if (this.redirect) {
                redirect = this.redirect;
            }
            if (!!rfid) {
                this.$store
                    .dispatch("signinUserInRfid", {
                        rfid,
                        redirect,
                    })
                    .then((data) => {
                        if (!data) {
                            this.$store.commit("toggleLoginLoader", false);
                            this.activateRFID();
                        }
                    });
            } else {
                this.$store.commit("toggleLoginLoader", false);
            }
        },
        submit_qr(qr_code) {
            var redirect = "";
            if (this.redirect) {
                redirect = this.redirect;
            }
            if (!!qr_code) {
                this.$store
                    .dispatch("signinUserInQr", {
                        qr_code,
                        redirect,
                    })
                    .then((data) => {
                        if (!data) {
                            this.$refs.scan_barcode.resetBarcode(true);
                        }
                    });
            } else {
            }
        },
        submit() {
            if (this.signing_in) {
                return;
            } else {
                this.signing_in = true;
            }

            clearTimeout(this.sign_in_timer);
            this.sign_in_timer = setTimeout(() => {
                if (!this.login_loader) this.signing_in = false;
                this.sign_in_timer = "";
            }, 2000); // 2 seconds

            this.$store.commit("toggleLoginLoader", true);
            this.usernameRules = [
                (v) => !!v || this.$t("lang.valid_username_required"),
                (v) =>
                    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(v) ||
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    (v.length <= 100 && v.length >= 8 && !/[-_=\+\.,'"<>/\(\)\{\}\[\]\?\|\\\\]+/.test(v)) ||
                    this.$t("lang.valid_username"),
            ];
            this.passwordRules = [(v) => !!v || this.$t("lang.password_required")];

            this.$nextTick(() => {
                if (this.validateForm("login_form")) {
                    const user = {
                        username: this.logDetails.username,
                        password: this.logDetails.password,
                        remember_me: this.logDetails.remember_me,
                    };
                    var redirect = "";
                    if (this.redirect) {
                        redirect = this.redirect;
                    }
                    this.$store
                        .dispatch("signinUserIn", {
                            user,
                            redirect,
                        })
                        .then((data) => {
                            if (!data) {
                                this.$store.commit("toggleLoginLoader", false);
                                if (this.sign_in_timer == "") this.signing_in = false;
                            }
                        });
                } else {
                    this.$store.commit("toggleLoginLoader", false);
                }
            });
        },
        clearMessage: function () {
            this.errorMessage = "";
            this.successMessage = "";
        },
    },
};
</script>
